import { REACT_APP_PERITADOR_API } from '../../config'
import axios from 'axios'

export async function getOriginChannels() {
    const response = await axios.get(`${REACT_APP_PERITADOR_API}/originChannels?filter[order]=order`)
    if (response.status === 200) {
        return response.data
    }
    return null

}